exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spec-table[data-v-30399067]{\n  width: 100%;\n}\n", ""]);

// exports
